import React, { useEffect, useState, useCallback, useContext } from "react"

// Core components
import CircularProgress from "@material-ui/core/CircularProgress"
import { RootContext } from 'RootContext';
import $ from 'jquery';
import { titleCase } from "title-case"
import ThumbUpIcon from '@material-ui/icons/ThumbUp';

// Pegaso components
import ErrorUtils from "components/Tools/ErrorUtils"
import { DetectPegasoDriver } from "components/Utils/DetectPegasoDriver";
import TracerUtils from "components/Utils/TracerUtils"
import UseIsMounted from "components/Utils/UseIsMounted"

export default function BlockerLoading(props) {
  const { getServicePort } = useContext(RootContext)
  const {
    JSON_tracerJson,
    JSON_serviceMessages,
    tracerEventRequest,
    shapeForBlocker,
    setTracerEventRequest,
    setIsSaving
  } = props

  const tracerJson = JSON.parse(JSON_tracerJson)
  const messages = JSON.parse(JSON_serviceMessages)
  const [apiUrl, setApiUrl] = useState(null);
  const IncrementoSecondiCiclo = 1000;
  const MaxCicli = 60 * 3 * IncrementoSecondiCiclo;

  const [output, SetOutput] = useState(null)
  const [secondiReali, setSecondiReali] = useState(0);
  const [driverParms, setDriverParms] = useState(null)
  const [currentEvent, setCurrentEvent] = useState(null)
  const [showCircularProgress, setShowCircularProgress] = useState(true)
  const [doEvent1, setDoEvent1] = useState(false)
  const [doEvent2, setDoEvent2] = useState(false)
  const isMounted = UseIsMounted()
  /*
      USE CALLBACK
  */
  const ErroreServizio = useCallback((bottone, xhr, textStatus, error) => {
    // error[0] = Nessun Blocker Locale specificato
    // error[1] = PegasoDriver - Dispositivo non raggiungibile (servizio...)
    // error[2] = TimeOut - Nessuna forma ricevuta

    var ErrorMess = '';
    var statusText = xhr.statusText ? xhr.statusText : null;
    var responseText = xhr.responseText ? xhr.responseText.trim() : null;
    var isHttps = apiUrl.includes('https');

    // Log Generico
    ErrorUtils.errorLog("BlockerLoading",
      'Service Error ' + bottone +
      ' - statusText=' + statusText +
      ' - textStatus=' + textStatus +
      ' - error=' + error +
      ' - responseText=' + responseText)

    // Errore Servizio: Servizio Non Attivo
    if (isHttps === true) {
      // HTTPS - NEW version PegasoDriver (>= 1.2.5)
      if (typeof responseText === 'string') {
        console.log(responseText)
        if (responseText !== '' || responseText !== null) {
          // Errore Servizio: Generico (se 'In Ricezione' non fare alert)
          if (responseText.includes("31") === false) {
            ErrorMess = responseText.toString();
          }
        }
      } else if (statusText === 'error' && textStatus === 'error' && (error === '' || error === null)) {
        ErrorMess = messages.error[1];
      }
    } else {
      // HTTP - OLD version PegasoDriver (<= 1.2.4)
      if (statusText === 'error' && textStatus === 'error' && (error === '' || error === null)) {
        ErrorMess = messages.error[1];
      } else if (typeof statusText === 'string') {
        if (statusText !== '' || statusText !== null) {
          // Errore Servizio: Generico (se 'In Ricezione' non fare alert)
          if (statusText.includes("31") === false) {
            ErrorMess = statusText.toString();
          }
        }
      }
    }

    // Se ce messaggio di errore fa alert e chiude finestra
    if (ErrorMess !== '') {
      setIsSaving(false)
      alert(ErrorMess)
    }
  }, [apiUrl, messages, setIsSaving])

  const StatusServizio = useCallback((sts) => {
    switch (sts) {
      case 0:
        SetOutput(messages.status[0]) // Discconect
        break;
      case 1:
        SetOutput(messages.status[1]) // Connect
        break;
      case 2:
        SetOutput(messages.status[2]) // attesa invio dati
        break;
      case 3:
        SetOutput(messages.status[3]) // dati inviati
        break;
      default:
        break;
    }
  }, [messages, SetOutput])

  /*/disconnect-blocker
      MANUAL REQUEST
  */
  // POST disconnectAndRespond - Status 2
  const disconnectAndRespond = useCallback(() => {
    StatusServizio(0);
    $.post({
      traditional: true,
      url: `${apiUrl}/disconnect-blocker`,
      contentType: 'application/json',
      crossDomain: true,
      data: JSON.stringify({
        blocker: driverParms.DescrizioneBlocker,
        codBlocker: driverParms.Blocker,
        comName: driverParms.PortaBlocker,
        blockerSetting: driverParms.TracerSettingJAVA,
        token1: driverParms.Token1,
      }),
      dataType: 'json',
      success: function (response) {
        console.log("disconnectAndRespond -> SUCCESS");
        setTracerEventRequest(null)
        setIsSaving(false)
      },
      error: function (xhr, textStatus, error) {
        console.log("disconnectAndRespond -> ERROR");
        ErroreServizio('DISCONNECT', xhr, textStatus, error)
      }
    });
  }, [driverParms, apiUrl, StatusServizio, ErroreServizio, setTracerEventRequest, setIsSaving])


  // POST disconnectAndEnd  - Fine lettura dati
  const disconnectAndEnd = useCallback(() => {
    StatusServizio(3);
    $.post({
      traditional: true,
      url: `${apiUrl}/disconnect-blocker`,
      contentType: 'application/json',
      crossDomain: true,
      data: JSON.stringify({
        blocker: driverParms.DescrizioneBlocker,
        codBlocker: driverParms.Blocker,
        comName: driverParms.PortaBlocker,
        blockerSetting: driverParms.TracerSettingJAVA,
        token1: driverParms.Token1,
      }),
      dataType: 'json',
      success: function (response) {
        console.log("disconnectAndEnd -> SUCCESS");
        setTracerEventRequest(null)
        setIsSaving(false)
      },
      error: function (xhr, textStatus, error) {
        console.log("disconnectAndEnd -> ERROR");
        ErroreServizio('DISCONNECT', xhr, textStatus, error)
      }
    });
  }, [driverParms, apiUrl, StatusServizio, ErroreServizio, setTracerEventRequest, setIsSaving])

  // POST connectAndRespond - Status 3
  const connectAndRespond = useCallback(() => {
    StatusServizio(1);
    $.post({
      traditional: true,
      url: `${apiUrl}/connect-blocker`,
      contentType: 'application/json',
      crossDomain: true,
      data: JSON.stringify({
        blocker: driverParms.DescrizioneBlocker,
        codBlocker: driverParms.Blocker,
        comName: driverParms.PortaBlocker,
        blockerSetting: driverParms.TracerSettingJAVA,
        token1: driverParms.Token1,
        shape: shapeForBlocker
      }),
      dataType: 'json',
      success: function (response) {
        console.log("connectAndRespond -> SUCCESS");
      },
      error: function (xhr, textStatus, error) {
        console.log("connectAndRespond -> ERROR");
        ErroreServizio('CONNECT', xhr, textStatus, error)
      }
    });
  }, [driverParms, apiUrl, StatusServizio, ErroreServizio, shapeForBlocker])

  // POST receiveAndRespond - Status 4
  const receiveAndRespond = useCallback(() => {
    StatusServizio(2);
    $.post({
      traditional: true,
      url: `${apiUrl}/receive-blocker`,
      contentType: 'application/json',
      crossDomain: true,
      data: JSON.stringify({
        blocker: driverParms.DescrizioneBlocker,
        codBlocker: driverParms.Blocker,
        comName: driverParms.PortaBlocker,
        blockerSetting: driverParms.TracerSettingJAVA,
        token1: driverParms.Token1,
      }),
      dataType: 'json',
      success: function (response) {
        if (atob(response) === "OK") {
          setDoEvent1(false)
          setDoEvent2(false)
          StatusServizio(3);
          setShowCircularProgress(false)
          TracerUtils.sleep(5000).then(() => {
            disconnectAndRespond()
          });
        }
        console.log("receiveAndRespond -> SUCCESS");
      },
      error: function (xhr, textStatus, error) {
        console.log("receiveAndRespond -> ERROR");
        ErroreServizio('RECEIVE (Wait)', xhr, textStatus, error)
      }
    });
  }, [driverParms, apiUrl, StatusServizio, ErroreServizio, disconnectAndRespond])

  /*
      AUTOMATIC REQUEST
  */
  // POST receiveWaitModeAndRespond - Status 5
  const receiveWaitModeAndRespond = useCallback((seconds, handleSetSeconds) => {
    StatusServizio(2);
    if (isMounted()) {
      $.post({
        traditional: true,
        url: `${apiUrl}/receive-blocker`,
        contentType: 'application/json',
        crossDomain: true,
        data: JSON.stringify({
          blocker: driverParms.DescrizioneBlocker,
          codBlocker: driverParms.Blocker,
          comName: driverParms.PortaBlocker,
          blockerSetting: driverParms.TracerSettingJAVA,
          token1: driverParms.Token1,
        }),
        dataType: 'json',
        success: function (response) {
          if (atob(response) === "OK") {
            console.log("receiveAndRespond -> SUCCESS");
            setDoEvent1(false)
            setDoEvent2(false)
            StatusServizio(3);
            setShowCircularProgress(false)
            TracerUtils.sleep(5000).then(() => {
              disconnectAndEnd()
            });
          }
        },
        error: function (xhr, textStatus, error) {
          if (isMounted()) {
            ErroreServizio('RECEIVE (Wait)', xhr, textStatus, error); // Importante per loggare "DATI NON SONO PRONTI"
            handleSetSeconds(seconds + IncrementoSecondiCiclo)
          }
        }
      });
    }
  }, [driverParms, apiUrl, StatusServizio, IncrementoSecondiCiclo, isMounted, disconnectAndEnd, ErroreServizio])

  // CicloReceiveWaitMode - Status 6
  const CicloReceiveWaitMode = useCallback(() => {
    StatusServizio(2);
    setSecondiReali(IncrementoSecondiCiclo)
  }, [StatusServizio, setSecondiReali, IncrementoSecondiCiclo])

  // POST connectAndReceive - Status 7
  const connectAndReceive = useCallback(() => {
    StatusServizio(1);
    $.post({
      traditional: true,
      url: `${apiUrl}/connect-blocker`,
      contentType: 'application/json',
      crossDomain: true,
      data: JSON.stringify({
        blocker: driverParms.DescrizioneBlocker,
        codBlocker: driverParms.Blocker,
        comName: driverParms.PortaBlocker,
        blockerSetting: driverParms.TracerSettingJAVA,
        token1: driverParms.Token1,
        shape: shapeForBlocker
      }),
      dataType: 'json',
      success: function (response) {
        console.log("connectAndRespond -> SUCCESS");
        CicloReceiveWaitMode();
      },
      error: function (xhr, textStatus, error) {
        console.log("connectAndRespond -> ERROR");
        ErroreServizio('CONNECT', xhr, textStatus, error)
      }
    });
  }, [driverParms, apiUrl, StatusServizio, CicloReceiveWaitMode, ErroreServizio, shapeForBlocker])

  // CicloConnect_Receive 
  const CicloConnect_Receive = useCallback(() => {
    setTimeout(connectAndReceive(), 300);
  }, [connectAndReceive])

  // POST allAndRespond - Status 8
  const allAndRespond = useCallback(() => {
    StatusServizio(0);
    $.post({
      traditional: true,
      url: `${apiUrl}/disconnect-blocker`,
      contentType: 'application/json',
      crossDomain: true,
      data: JSON.stringify({
        tracer: driverParms.DescrizioneBlocker,
        codBlocker: driverParms.Blocker,
        comName: driverParms.PortaBlocker,
        tracerSetting: driverParms.TracerSettingJAVA,
        token1: driverParms.Token1
      }),
      dataType: 'json',
      success: function (response) {
        CicloConnect_Receive();
      },
      error: function (xhr, textStatus, error) {
        CicloConnect_Receive();
      }
    });
  }, [driverParms, apiUrl, StatusServizio, CicloConnect_Receive])

  /*
      USE EFFECT
  */
  useEffect(() => {
    async function detect() {
      const url = await DetectPegasoDriver(getServicePort());
      setApiUrl(url)
    }
    detect();
  }, [getServicePort]);

  useEffect(() => {
    if (tracerJson) {
      if (!driverParms) {
        setDriverParms(
          {
            Token1: tracerJson.token1,
            Blocker: tracerJson.codTracer,
            PortaBlocker: tracerJson.comName,
            TracerSettingJAVA: tracerJson.tracerSetting,
            DescrizioneBlocker: tracerJson.tracer
          })
      }
    }
  }, [tracerJson, driverParms])

  useEffect(() => {
    if (apiUrl !== null) {
      if (tracerEventRequest) {
        setCurrentEvent(tracerEventRequest)
        setDoEvent1(true)
      }
    }
  }, [apiUrl, tracerEventRequest])

  useEffect(() => {
    if (apiUrl !== null) {
      if (doEvent1) {
        switch (currentEvent) {
          case "ALL":
            allAndRespond()
            setDoEvent2(true)
            break;
          case "DISCONNECT":
            disconnectAndRespond();
            setDoEvent2(true)
            break;
          case "CONNECT":
            connectAndRespond()
            setDoEvent2(true)
            break;
          case "RECEIVE":
            receiveAndRespond()
            setDoEvent2(true)
            break;
          default:
            break;
        }
        setDoEvent1(false)
      }
    }
  }, [apiUrl, allAndRespond, connectAndRespond, disconnectAndRespond, receiveAndRespond, currentEvent, doEvent1, IncrementoSecondiCiclo])

  useEffect(() => {
    if (apiUrl !== null) {
      if (driverParms) {
        if (driverParms.Blocker) {
          if (doEvent2) {
            if (currentEvent === "ALL") {
              if (secondiReali > 0) {
                if (secondiReali < MaxCicli) {
                  TracerUtils.sleep(IncrementoSecondiCiclo).then(() => {
                    receiveWaitModeAndRespond(secondiReali, setSecondiReali);
                  });
                } else {
                  alert(messages.error[2])
                  setIsSaving(false)
                }
              }
            }
          }
        }
      }
    }
  }, [apiUrl, driverParms, doEvent2, secondiReali, MaxCicli, receiveWaitModeAndRespond, IncrementoSecondiCiclo, currentEvent, messages, setIsSaving])

  return (<div>
    {output ? titleCase(output) : null}
    {showCircularProgress ?
      <CircularProgress />
      : <ThumbUpIcon />
    }
    <br />
  </div>)
}